import React from "react"
import Modal from "react-bootstrap/Modal"

const ResponseModal = (props) => {
  return (
    <div>
      <Modal size="lg" show={props.show} centered>
        <Modal.Body className="p-0 rounded-20 position-relative">
          <div className="container"></div>
          <div className="row justify-content-center align-center confirm-modal_wrapper p-5">
            <div className="d-flex justify-content-center align-center m-auto">
              <img src={props.icon} alt="response" />
            </div>
            <h5 className="my-3">{props.title}</h5>
            <p className="mt-3">{props.text1}</p>
            <p className="mt-2">{props.text2}</p>
            <div className="flex-column justify-content-center col-lg-6">
              <div className="form-group col-md-12 my-3">
                <button
                  type="button"
                  onClick={props.btnAction}
                  className="btn sparkle--button__green sparkle--button__shadow px-5 btn-block w-100"
                >
                  {props.btnText}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default ResponseModal
